// extracted by mini-css-extract-plugin
module.exports = {"app-container":"AppRoute_app-container__H2NKZ"};